import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import theme from './theme';

import Dashboard from './pages/Dashboard';
import AddClient from './pages/AddClient';
import ClientProfile from './pages/ClientProfile';
import ClientList from './pages/ClientList';
import ArchivedClients from './pages/ArchivedClients';
import Login from './pages/Login';
import Staff from './pages/Staff';
import AcceptInvite from './pages/AcceptInvite';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<ClientList />} />
              <Route path="add-client" element={<AddClient />} />
              <Route
                path="archived-clients"
                element={
                  <ProtectedRoute allowedRoles={['admin', 'manager']}>
                    <ArchivedClients />
                  </ProtectedRoute>
                }
              />
              <Route path="client/:id" element={<ClientProfile />} />
              <Route
                path="staff"
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <Staff />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 